import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {SemanaProyecto} from '../../interfaces/interfaces';
import {DateTime} from 'luxon';

@Component({
  selector: 'app-programacion',
  templateUrl: './programacion.component.html',
  styleUrls: ['./programacion.component.scss'],
})
export class ProgramacionComponent implements OnInit {

  @Input() datos: SemanaProyecto;

  subtitulo: string;

  constructor(
    public modalCtrl: ModalController
  ) {}

  ngOnInit() {
    this.subtitulo = 'SEMANA ' + this.datos.semana + ': ' +
      DateTime.fromSQL(this.datos.datosSemana[0].fecha).toFormat('d/LL') + ' - ' +
      DateTime.fromSQL(this.datos.datosSemana[4].fecha).toFormat('d/LL');
  }

}
